import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import Storefront from 'utils/storefront';
import * as queries from 'utils/storefront/queries';
import { edgesToNodes } from 'utils/storefront/format-resource';
import CartUpSellSwiper from './cart-upsell-swiper';

const CartUpSellPairsWith = ({
  upSellData,
  index,
  isOpen,
  lastItem,
  lastItemPairsWithData,
}) => {
  const storefront = Storefront.getInstance();
  const [products, setProducts] = useState([]);
  const {
    type,
    title,
  } = upSellData || {};

  const getPairsWithProducts = async (ids) => {
    const response = await storefront.request({
      query: queries.getProductsByIds,
      variables: {
        ids,
      },
    });

    if (!response.data) {
      // eslint-disable-next-line no-console
      console.error(
        'product-grid/product-grid.js: Storefront API request failed',
        response,
      );
      return [];
    }

    const existingProducts = response.data.nodes.filter(
      (product) => product != null,
    );

    if (!existingProducts.length) {
      return [];
    }


    return edgesToNodes(existingProducts, 'product');
  };

  useEffect(() => {
 
    if (type === 'ab-test') { 
      setProducts([]);
      if(isOpen){
          getPairsWithProducts(JSON.parse(lastItemPairsWithData.value))
          .then((items) => setProducts(items));
      }

    }

  }, [isOpen, lastItem, lastItemPairsWithData]);


  if (!products.length) return null;

  return (
    <CartUpSellSwiper
    index={index}
    products={products}
    title={title.split(",")[0]}
    cartEmpty={false}
    type={"ab-test"}
  />
  );
};

export default CartUpSellPairsWith;
